import { render, staticRenderFns } from "./SiteWeb.vue?vue&type=template&id=38b4a306&"
import script from "./SiteWeb.vue?vue&type=script&lang=js&"
export * from "./SiteWeb.vue?vue&type=script&lang=js&"
import style0 from "./SiteWeb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports